import '../styles/CompletionScreen.css';

function CompletionScreen({ sessionId, workflowPath, firstName }) {

  const stripeLink = process.env.REACT_APP_STRIPE_PAYMENT_LINK || 'https://buy.stripe.com/14AeV7f6F3YF3CV9Gf8ww00';

  return (
    <div className="completion-screen">
      {workflowPath === 'referral_path' ? (
        <div className="completion-message">
          <p>You're amazing for helping your friend out! 🙌</p>
          <p>We'll reach out to coordinate and get them connected with great people at one of our future events.</p>
        </div>
      ) : (
        <div className="completion-message">
          <h2>Perfect! You're all set {firstName} 🎉</h2>
          <div className="instructions">
            <h3>Here's what happens next:</h3>
            <ol>
              <li>We review your profile and look for potential matches</li>
              <li>If we find someone who matches your vibe, we'll reach out to them</li>
              <li>With their permission, we'll make the introduction</li>
              <li>You'll receive an update from us soon!</li>
            </ol>
            <p className="goal">Our goal: Help you make meaningful connections with great people.</p>
          </div>
        </div>
      )}

      {workflowPath === 'single_path' && (
        <div className="payment-section">
          <h3>Get in on tonight's dating pool!</h3>
          <p>If we think someone matches you from your sign-up form, we'll try to make an intro.</p>
          <p className="entry-fee">Entry fee: $5 per person</p>

          <div className="payment-options">
            <div className="payment-option">
              <h4>Pay with Credit Card</h4>
              <a
                href={stripeLink}
                target="_blank"
                rel="noopener noreferrer"
                className="payment-button stripe-button"
              >
                Enter Dating Pool
              </a>
            </div>
          </div>
        </div>
      )}

      {workflowPath === 'single_path' && (
        <div className="events-section">
          <h3>Interested in upcoming events?</h3>
          <a
            href="https://pitch-a-friend.com/buffalo#events"
            target="_blank"
            rel="noopener noreferrer"
            className="events-button"
          >
            View Upcoming Events
          </a>
        </div>
      )}
    </div>
  );
}

export default CompletionScreen;
